/**
 * Created by cranium on 2/19/16.
 */

var $ = require('js/sw-jquery/sw-jquery');

$(document).ready(function () {
  $('[data-sw-resend-verification]').submit(function () {
    var $submitButton = $('[name="resend"]', this);
    // don't submit it twice..
    if ($submitButton.hasClass('waiting') || $submitButton.hasClass('success')) {
      return false;
    }
    $submitButton.removeClass('fail btn-primary').addClass('btn waiting');
    var $form = $(this);
    $.ajax({
      type:"POST",
      async:true,
      url: $form.attr('action') + '/json',
      data: $form.serialize(),
      dataType: 'json',
      success: function (data) {
        if (data.success) {
          $submitButton.removeClass('waiting');
        } else {
          $submitButton.removeClass('waiting').addClass('fail');
        }
      },
      failure: function () {
        $submitButton.removeClass('waiting').addClass('fail');
      }
    });
    return false;
  });

  $('[data-sw-resend-verification-link]').click(function(){
    $('[data-sw-resend-verification]').submit();
  });
});
